import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => {
  const {minHeight:space} = theme.mixins.toolbar;
  const rez = {
    map: {
      position: "absolute",
      // right:0,
      // width: 'calc(100vw - 244px)',
      // width:props=>`calc(100vw -${props.paletteWidth}px)`,
      // width:'100%',
      height: `calc(100vh - ${space+30}px)`,
      //top:`${space}px`,
      top: 90,

      "@media screen and (max-width: 768px)": {
        top: 56,
        //height: `calc(100vh - 96px)`,
      },

      "@media screen and (max-width: 480px)": {
        top: 58,
        height: `calc(100vh - 96px)`,
      },

      // height:'100vh',
      "&>.mapContainer":{
        position: "absolute",
        right:0,
        width:'100%',
        bottom: 0,
        top: 56,

        "@media screen and (max-width: 1280px)": {
          top: 100,
        },

        "@media screen and (max-width: 640px)": {
          top: 116,
        },

        "@media screen and (max-width: 480px)": {
          top: 70,
        },

      },
      "&>.mapContainer>.mapContainerInternal":{
        position: "absolute",
        right:0,
        width:'100%',
        bottom:'0px',
        top: 0,

        "@media screen and (max-width: 480px)": {
          top: 0,
        },
      }
    },
    contentContainer: {
      position: "absolute",
      zIndex: 1000,
      left: "50%",
      top: "50%",
      display: "flex",
      flexWrap: "wrap",
      overflowX: "auto",
      width: "100%"
    },
    geozoneIntersectionsTableWrapper: {
      position: "absolute",
      top: "50%",
      marginTop: "2rem",
      width: "calc(100% - 30px)",
      right:"0px"
    }
  }

  return rez
});

export default useStyles;
